import React, { useState } from 'react'

import { useLocation } from '@reach/router'

import Link from 'src/components/link/index'
import Dialog from './dialog'

import styles from './index.module.scss'

const Footer = () => {
	const { pathname } = useLocation()

	const [open, setOpen] = useState(false)
	const [address, setAddress] = useState(``)

	const openDialog = (address) => {
		setOpen(true)
		setAddress(address)
	}

	return (
		<footer className={styles.footer}>
			<div className={styles.wrapper}>
				<div className={styles.logo}>
					<Link to={pathname === '/' ? '/#' : '/'}>WE ARE THE FIT</Link>
				</div>

				<ul className={styles.sns}>
					<li>
						<Link to="https://www.facebook.com/wearethefit/">
							<svg viewBox="0 0 32 32">
								<path d="M16 1C7.71572 1 1 7.75676 1 16.0917C1 23.6242 6.48525 29.8678 13.6562 31V20.4541H9.84766V16.0917H13.6562V12.7668C13.6562 8.98444 15.8957 6.89518 19.322 6.89518C20.9632 6.89518 22.6797 7.18994 22.6797 7.18994V10.9039H20.7883C18.925 10.9039 18.3437 12.0673 18.3437 13.2608V16.0917H22.5039L21.8389 20.4541H18.3437V31C25.5147 29.8678 31 23.6245 31 16.0917C31 7.75676 24.2843 1 16 1Z" />
							</svg>
						</Link>
					</li>
					<li>
						<Link to="https://twitter.com/WEARETHEFIT24">
							<svg viewBox="0 0 32 32">
								<path d="M18.2833 14.3857L27.2178 4H25.1006L17.3427 13.0177L11.1466 4H4L13.3698 17.6364L4 28.5274H6.11732L14.3098 19.0044L20.8534 28.5274H28L18.2827 14.3857H18.2833ZM15.3833 17.7566L14.4339 16.3987L6.88022 5.59389H10.1323L16.2282 14.3137L17.1776 15.6716L25.1016 27.006H21.8495L15.3833 17.7571V17.7566Z" />
							</svg>
						</Link>
					</li>
					<li>
						<Link to="https://www.instagram.com/wearethefit_24/">
							<svg viewBox="0 0 32 32">
								<path d="M15.9303 26.6452C19.4203 26.6452 19.8332 26.6317 21.2117 26.5689C22.4858 26.5108 23.1779 26.2981 23.6386 26.1191C24.2487 25.882 24.684 25.5988 25.1415 25.1417C25.5991 24.6841 25.8824 24.2489 26.119 23.6388C26.2979 23.1781 26.5106 22.486 26.5687 21.2119C26.6315 19.8339 26.645 19.4205 26.645 15.9305C26.645 12.4406 26.6315 12.0276 26.5687 10.6492C26.5106 9.37504 26.2979 8.68297 26.119 8.22228C25.8819 7.61218 25.5986 7.17691 25.1415 6.71933C24.684 6.26175 24.2487 5.97849 23.6386 5.74192C23.1779 5.56294 22.4858 5.35023 21.2117 5.29213C19.8338 5.22935 19.4203 5.21586 15.9303 5.21586C12.4404 5.21586 12.0269 5.22935 10.649 5.29213C9.37485 5.35023 8.68278 5.56294 8.22209 5.74192C7.61199 5.97901 7.17672 6.26227 6.71915 6.71933C6.26157 7.17691 5.97831 7.61218 5.74174 8.22228C5.56275 8.68297 5.35005 9.37504 5.29194 10.6492C5.22917 12.0271 5.21568 12.4406 5.21568 15.9305C5.21568 19.4205 5.22917 19.8334 5.29194 21.2119C5.35005 22.486 5.56275 23.1781 5.74174 23.6388C5.97883 24.2489 6.26209 24.6841 6.71915 25.1417C7.1762 25.5993 7.61199 25.8826 8.22209 26.1191C8.68278 26.2981 9.37485 26.5108 10.649 26.5689C12.0269 26.6317 12.4404 26.6452 15.9303 26.6452ZM15.9303 29C12.3808 29 11.9356 28.985 10.5416 28.9211C9.15074 28.8579 8.2003 28.6368 7.3692 28.3136C6.50955 27.9795 5.78065 27.5328 5.05433 26.806C4.3275 26.0792 3.88082 25.3508 3.54672 24.4912C3.22351 23.66 3.0025 22.7096 2.93921 21.3187C2.8754 19.9247 2.86035 19.4796 2.86035 15.93C2.86035 12.3804 2.8754 11.9353 2.93921 10.5413C3.0025 9.1504 3.22351 8.19997 3.54672 7.36886C3.88082 6.50922 4.3275 5.78031 5.05433 5.054C5.78116 4.32717 6.50955 3.88049 7.3692 3.54638C8.2003 3.22317 9.15074 3.00217 10.5416 2.93888C11.9356 2.87506 12.3808 2.86002 15.9303 2.86002C19.4799 2.86002 19.9251 2.87506 21.3191 2.93888C22.71 3.00217 23.6604 3.22317 24.4915 3.54638C25.3511 3.88049 26.08 4.32717 26.8064 5.054C27.5332 5.78083 27.9799 6.50922 28.314 7.36886C28.6372 8.19997 28.8582 9.1504 28.9215 10.5413C28.9853 11.9353 29.0003 12.3804 29.0003 15.93C29.0003 19.4796 28.9853 19.9247 28.9215 21.3187C28.8582 22.7096 28.6372 23.66 28.314 24.4912C27.9799 25.3508 27.5332 26.0797 26.8064 26.806C26.0795 27.5328 25.3511 27.9795 24.4915 28.3136C23.6604 28.6368 22.71 28.8579 21.3191 28.9211C19.9251 28.985 19.4799 29 15.9303 29Z" />
								<path d="M15.9304 22.6412C12.2236 22.6412 9.21924 19.6363 9.21924 15.93C9.21924 12.2238 12.2241 9.21892 15.9304 9.21892C19.6366 9.21892 22.6415 12.2238 22.6415 15.93C22.6415 19.6363 19.6366 22.6412 15.9304 22.6412ZM15.9304 11.5737C13.5242 11.5737 11.574 13.5244 11.574 15.93C11.574 18.3357 13.5247 20.2864 15.9304 20.2864C18.336 20.2864 20.2867 18.3357 20.2867 15.93C20.2867 13.5244 18.336 11.5737 15.9304 11.5737Z" />
								<path d="M22.9072 21.3393C23.7733 21.3393 24.4755 22.0415 24.4755 22.9076C24.4755 23.7738 23.7733 24.476 22.9072 24.476C22.041 24.476 21.3389 23.7738 21.3389 22.9076C21.3389 22.0415 22.041 21.3393 22.9072 21.3393Z" />
							</svg>
						</Link>
					</li>
				</ul>

				<div className={styles.message}>
					We are not just a gym. We want to be a place to create a purpose for your life to move your body.
				</div>

				<div className={styles.gyms}>
					<div>
						<div className={styles.gymGroup}>
							<Link className={styles.gymName} to="/gyms/toritsudai/">
								WE ARE THE FIT <br />
								TORITSUDAI
							</Link>
							<div className={styles.gymAddress}>
								〒152-0031 <br />
								東京都目黒区中根1丁目3-11
							</div>
						</div>
						<div className={styles.gymGroup}>
							<Link className={styles.gymName} to="/gyms/toritsudai/">
								WE ARE THE FIT <br />
								TORITSUDAI ANNEX
							</Link>
							<div className={styles.gymAddress}>
								〒152-0031 <br />
								東京都目黒区中根1丁目3-3 2F
							</div>
						</div>
						<div className={styles.gymTel}>TEL：03-5726-8065</div>
						<button onClick={() => openDialog(`info@thefit.jp`)}>お問い合わせはこちら</button>
					</div>

					<div>
						<div className={styles.gymGroup}>
							<Link className={styles.gymName} to="/gyms/ekoda/">
								WE ARE THE FIT <br />
								EKODA
							</Link>
							<div className={styles.gymAddress}>
								〒176-0005 <br />
								東京都練馬区旭丘1-71-6 <wbr />
								プロパティ江古田3F
							</div>
						</div>
						<div className={styles.gymTel}>TEL：03-5906-5777</div>
						<button onClick={() => openDialog(`ekoda@thefit.jp`)}>お問い合わせはこちら</button>
					</div>

					<div>
						<div className={styles.gymGroup}>
							<Link className={styles.gymName} to="/gyms/yoga/">
								WE ARE THE FIT <br />
								YOGA
							</Link>
							<div className={styles.gymAddress}>
								〒158-0097 <br />
								東京都世田谷区用賀4丁目3-1 <wbr />
								ファースト用賀ビル3F
							</div>
						</div>
						<div className={styles.gymTel}>TEL：03-6411-7177</div>
						<button onClick={() => openDialog(`yoga@thefit.jp`)}>お問い合わせはこちら</button>
					</div>

					<div>
						<div className={styles.gymGroup}>
							<Link className={styles.gymName} to="/gyms/hiroo/">
								WE ARE THE FIT <br />
								HIROO
							</Link>
							<div className={styles.gymAddress}>
								〒150-0012 <br />
								東京都渋谷区広尾5-14-28 2F
							</div>
						</div>
						<div className={styles.gymTel}>TEL：03-6432-5075</div>
						<button onClick={() => openDialog(`hiroo@thefit.jp`)}>お問い合わせはこちら</button>
					</div>
				</div>

				<ul className={styles.nav1}>
					<li>
						<Link to={pathname === '/' ? '/#news' : '/news/'}>NEWS</Link>
					</li>
					<li>
						<Link to="/#about">ABOUT</Link>
					</li>
					<li>
						<Link to="/#gyms">GYMS</Link>
					</li>
					<li>
						<Link to="/#price">PRICE</Link>
					</li>
					<li>
						<Link to="/faq/">FAQ</Link>
					</li>
					<li>
						<Link to="/beginners/">FOR BEGINNER</Link>
					</li>
				</ul>

				<ul className={styles.nav2}>
					<li>
						<Link to="/company/">会社概要</Link>
					</li>
					<li>
						<Link to="/agreement/">会員規則</Link>
					</li>
					<li>
						<Link to="/privacy/">プライバシーポリシー</Link>
					</li>
					<li>
						<Link to="/law/">特定商取引法に基づく表記</Link>
					</li>
				</ul>

				<div className={styles.copyright}>
					<span>© 2026 WE ARE THE FIT. All Rights Reserved</span>
				</div>
			</div>

			<Dialog isOpen={open} close={() => setOpen(false)} address={address} />
		</footer>
	)
}

export default Footer
